import useCopyToClipboard from "@/hooks/useCopyToClipboard";
import { IconButton, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import Iconify from "../iconify";

CopyButton.propTypes = {
    textToCopy: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
}

export default function CopyButton({ textToCopy, size = 'medium' }) {

    const [isCopied, setIsCopied] = useState(false);

    const tooltipTitle = isCopied ? 'Copiado!' : 'Copiar';

    const { copy } = useCopyToClipboard();

    function onCopyCode(text) {
        copy(text);
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 2000);
    }


    return (
        <Tooltip title={tooltipTitle}>
            <IconButton size={size} onClick={() => onCopyCode(textToCopy || '')}>
                <Iconify icon="eva:copy-fill" width={size === 'small' ? 16 : 20} />
            </IconButton>
        </Tooltip>
    )
}